var React = require('react');

function Package (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.5"},[React.createElement("rect",{"width":"16","height":"16","transform":"translate(0.666626)","fill":"white","key":0}),React.createElement("path",{"d":"M1.99994 4.66683L8.66661 1.3335L15.3333 4.66683M1.99994 4.66683V10.6668L8.66661 14.3335L15.3333 10.6668V4.66683M1.99994 4.66683L8.66661 8.3335L15.3333 4.66683M5.33327 3.00016L11.9999 6.3335V9.00016M8.66661 8.66683V14.0002","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Package.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Package;

Package.default = Package;
